import React from "react";
import Slider from "react-slick";
import LoginSliderImage1 from "../../../styles/img/default-login-banner.png";

export const LoginSlider = ({ loginWebBannersList }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="df-login-slider">
        {loginWebBannersList?.length > 0 ? (
          <Slider {...settings}>
            {loginWebBannersList?.map((banner) => (
              <div key={banner?.id}>
                <img src={banner?.image} alt={banner?.title} />
              </div>
            ))}
          </Slider>
        ) : (
          <div>
            <img src={LoginSliderImage1} alt="Default Banner" />
          </div>
        )}
      </div>
    </>
  );
};
